import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  CustomElementsDefineOptions,
  defineCustomElements,
} from '@savvaslearning/cel-components/dist-stencil/loader';
import { AverageGrowthMetricScoreWrapperComponent } from './components/average-growth-metric-score-wrapper/average-growth-metric-score-wrapper.component';
import { AverageGrowthScoreWrapperComponent } from './components/average-growth-score-wrapper/average-growth-score-wrapper.component';
import { ErrorComponent } from './components/error/error.component';
import { GrowthMetricScoreGraphComponent } from './components/growth-metric-score-graph/growth-metric-score-graph.component';
import { GrowthScoreCardComponent } from './components/growth-score-card/growth-score-card.component';
import { GrowthScoreGraphComponent } from './components/growth-score-graph/growth-score-graph.component';
import { LoaderPlaceholderComponent } from './components/loader-placeholder/loader-placeholder.component';
import { MultiProgressBarComponent } from './components/multi-progress-bar/multi-progress-bar.component';
import { OverlaySpinnerComponent } from './components/overlay-spinner/overlay-spinner.component';
import { PopoverTableComponent } from './components/popover-table/popover-table.component';
import { AssessmentReportingTypeLabel } from './pipes/assessmentReportingTypeLabel.pipe';

defineCustomElements(window, {
  transformTagName: (tagName: string) => `growth-report-${tagName}`,
} as CustomElementsDefineOptions);

@NgModule({
  declarations: [
    ErrorComponent,
    OverlaySpinnerComponent,
    MultiProgressBarComponent,
    PopoverTableComponent,
    GrowthScoreCardComponent,
    AverageGrowthScoreWrapperComponent,
    GrowthScoreGraphComponent,
    AssessmentReportingTypeLabel,
    LoaderPlaceholderComponent,
    AverageGrowthMetricScoreWrapperComponent,
    GrowthMetricScoreGraphComponent,
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    ErrorComponent,
    OverlaySpinnerComponent,
    MultiProgressBarComponent,
    PopoverTableComponent,
    TranslateModule,
    GrowthScoreCardComponent,
    AverageGrowthScoreWrapperComponent,
    GrowthScoreGraphComponent,
    GrowthMetricScoreGraphComponent,
    AssessmentReportingTypeLabel,
    LoaderPlaceholderComponent,
    AverageGrowthMetricScoreWrapperComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
